import * as yup from "yup";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";

export type FillExcavationMaterialFormProps = {
    id: string;
    returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: FillExcavationMaterialInput;
    action: "post" | "put";
};

export type FillExcavationMaterialInput = {
    fillExcavationMaterialId: bigint;
    applicationId: number;
    applicationInspectionId: number;
    // Historical excavation depth compliance fields - preserved for historical data
    excavationDepthComplianceId?: number;
    excavationDepthComment?: string;
    // New direct depth field - used going forward
    excavationDepth: number;
    areaReplacedComplianceId: number;
    areaReplacedComment: string;
    areaReplacedLength: number;
    areaReplacedWidth: number;
    replacementMaterialComplianceId: number;
    replacementMaterialComment: string;
    
    // Media Layer fields
    mediaLayer1ComplianceId: number;
    mediaLayer1Comment: string;
    mediaLayer2ComplianceId: number;
    mediaLayer2Comment: string;
    mediaLayer2Bottom: number;
    mediaLayer2Benchmark: number;
    
    dateCreated: Date|string;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    markAll: number;
    inspectionStatusId:number;
    areaReplacedCompliance?: ComplianceOptions;
    // Historical excavation depth compliance - preserved for historical data
    excavationDepthCompliance?: ComplianceOptions;
    replacementMaterialCompliance?: ComplianceOptions;

};
export type ComplianceData = {
    id: string;
    name: string;
};

export const schema = yup.object().shape({
  
      excavationDepth: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
      .when("areaReplacedComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then:yup.number()
          .min(1, "Excavation Depth (ft) is required")
          .required("Excavation Depth (ft) is required")
          .typeError("Excavation Depth (ft) is required"),
        otherwise: yup.number().nullable().notRequired()
      }),
      areaReplacedComplianceId: yup
      .number()
      .min(1, "Area Replaced Compliance is required")
      .required("Area Replaced Compliance is required")
      .typeError("Area Replaced Compliance is required"),
      areaReplacedComment: yup.string().nullable(true)
      .when("areaReplacedComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Area Replaced Comment is required")
        .typeError("Area Replaced Comment is required"),
        otherwise: yup.string().nullable().notRequired()
      }),
      areaReplacedLength: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
      .when("areaReplacedComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then:yup.number()
      .min(1, "Area Replaced Length(ft) is required")
      .required("Area Replaced Length(ft) is required")
      .typeError("Area Replaced Length(ft) is required"),
        otherwise: yup.number().nullable().notRequired()
      }),
      areaReplacedWidth: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
      .when("areaReplacedComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then:yup.number()
      .min(1, "Area Replaced Width(ft) is required")
      .required("Area Replaced Width(ft) is required")
      .typeError("Area Replaced Width(ft) is required"),
        otherwise: yup.number().nullable().notRequired()
      }),
      replacementMaterialComplianceId: yup
      .number()
      .min(1, "Replacement Material Compliance is required")
      .required("Replacement Material Compliance is required")
      .typeError("Replacement Material Compliance is required"),
      replacementMaterialComment: yup.string().nullable(true)
      .when("replacementMaterialComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Replacement Material Comment is required")
        .typeError("Replacement Material Comment is required"),
        otherwise: yup.string().nullable().notRequired()
      }),
      
      // Media Layer validation schema
      mediaLayer1ComplianceId: yup
        .number()
        .min(1, "Media Layer 1 Compliance is required")
        .required("Media Layer 1 Compliance is required")
        .typeError("Media Layer 1 Compliance is required"),
      mediaLayer1Comment: yup.string().nullable(true)
        .when("mediaLayer1ComplianceId", {
          is: (val: any) => val === Constants.Out_of_Compliance,
          then: yup.string().required("Media Layer 1 Comment is required")
            .typeError("Media Layer 1 Comment is required"),
          otherwise: yup.string().nullable().notRequired()
        }),
      mediaLayer2ComplianceId: yup
        .number()
        .min(1, "Media Layer 2 Compliance is required")
        .required("Media Layer 2 Compliance is required")
        .typeError("Media Layer 2 Compliance is required"),
      mediaLayer2Comment: yup.string().nullable(true)
        .when("mediaLayer2ComplianceId", {
          is: (val: any) => val === Constants.Out_of_Compliance,
          then: yup.string().required("Media Layer 2 Comment is required")
            .typeError("Media Layer 2 Comment is required"),
          otherwise: yup.string().nullable().notRequired()
        }),
      mediaLayer2Bottom: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
        .when("mediaLayer2ComplianceId", {
          is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
          then: yup.number()
            .min(1, "Media Layer 2 Bottom is required")
            .required("Media Layer 2 Bottom is required")
            .typeError("Media Layer 2 Bottom is required"),
          otherwise: yup.number().nullable().notRequired()
        }),
      mediaLayer2Benchmark: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
        .when("mediaLayer2ComplianceId", {
          is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
          then: yup.number()
            .min(1, "Media Layer 2 Benchmark is required")
            .required("Media Layer 2 Benchmark is required")
            .typeError("Media Layer 2 Benchmark is required"),
          otherwise: yup.number().nullable().notRequired()
        }),
  });
